<template>
      <div v-if="isVisible" class="container">
            <div class="text d-flex align-items-center my-auto m-4 font-weight-bold">Merci de prendre en considération que ce produit retardera votre commande de 24H</div>
            <button @click="hideComponent" class="button">Je comprends</button>
      </div>
</template>   
<script >

export default ({
      name: "Notification",

      data() {
            return {
                  isVisible: true,
            };
      },
      methods: {
            hideComponent() {
                  this.isVisible = false;
            },
      },
})

</script>
          
          
<style scoped>
.container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      background-color: #ffb320;
      box-sizing: border-box;
      max-width: 960px;
      border-top: 1px solid #eaeaea;
      padding: 5px;
      margin-top: 5px;;
}

@media (min-width: 600px) {
      .container {
            flex-direction: row;
            justify-content: space-between;
      }
}

.text {
      flex: 1;
      font-size: 16px;
      color: #000;
      
      text-align: left;
      white-space: break-spaces;
      margin-top: 10px;

}

.button {
      border: none;
      border-radius: 6px;
      background-color: #121212;
      color: #fff;
      padding: 9px 24px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
}


/* Mobile Version */
@media (max-width: 575.98px) {
      .button {
            margin-top: 20px;
      }

}
</style>